<template>
  <div>
    <p>Loading...</p>
    {{ error }}
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  data() {
    return {
      error: ''
    }
  },
  methods: {
    handleLoginEvent(data) {
      if (!data.error) {
        this.fromContext();
        this.watchImages();
        this.filterImages();
        this.$router.push(data.state.target || "/");
      }
    },
    ...mapActions(['fromContext', 'filterImages', 'watchImages'])
  },
  created() {
    this.$auth.handleAuthentication().then(() => {})
    .catch(err => { this.error = err.errorDescription });
  }
};
</script>